export default "__VITE_ASSET__78e1a251__"